import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send, ShieldCheck } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Avatar } from "@/components/Brand";
import { api, formatApiError } from "@/lib/api";

export function CommentsSheet({ short, onClose, onAdded }) {
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");

  useEffect(() => {
    if (short) api.get(`/shorts/${short.id}/comments`).then((r) => setItems(r.data));
  }, [short]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    try {
      const { data } = await api.post(`/shorts/${short.id}/comments`, { text });
      setItems((i) => [...i, data]);
      setText("");
      onAdded();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <Sheet open={!!short} onOpenChange={(o) => !o && onClose()}>
      <SheetContent side="bottom" className="mx-auto h-[70dvh] max-w-lg rounded-t-3xl flex flex-col" data-testid="comments-sheet">
        <SheetHeader><SheetTitle>Comentários</SheetTitle><SheetDescription className="sr-only">Comentários do vídeo curto</SheetDescription></SheetHeader>
        <p className="flex items-center gap-1.5 text-xs text-violet-300"><ShieldCheck size={13} /> Protegido pelo Guarda-Costas IA</p>
        <div className="no-scrollbar mt-3 flex-1 space-y-3 overflow-y-auto" data-testid="comments-list">
          {items.length === 0 && <p className="py-10 text-center text-sm text-muted-foreground">Nenhum comentário ainda. Seja gentil e comente primeiro!</p>}
          {items.map((c) => (
            <div key={c.id} className="flex gap-2.5" data-testid="comment-item">
              <Avatar name={c.user_name} src={c.avatar} size={30} />
              <div><p className="text-xs font-bold text-white/80">{c.user_name}</p><p className="text-sm">{c.text}</p></div>
            </div>
          ))}
        </div>
        <form onSubmit={send} className="mt-3 flex gap-2">
          <input value={text} onChange={(e) => setText(e.target.value)} maxLength={300} placeholder="Comente com respeito…" className="h-11 flex-1 rounded-full bg-white/5 px-4 text-sm outline-none ring-1 ring-white/10 focus:ring-[hsl(var(--gold))]" data-testid="comment-input" />
          <button type="submit" className="grid h-11 w-11 place-items-center rounded-full bg-[hsl(var(--gold))] text-[#0B0F17]" data-testid="comment-send-button"><Send size={17} /></button>
        </form>
      </SheetContent>
    </Sheet>
  );
}
